export default __webpack_public_path__ + "static/media/img_footer-banner-v2.9ccf7f54.svg";